import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'

export interface Organization {
    organizationId: string
    sapCode: string
    vatCode: string
}
export interface OrganizationInfo {
    active: boolean
    attributes: {
        sapCode: string
        vatCode: string
    }
    companyId: string
    companyName: string
    companyType: string
}
@Injectable()
export class OrganizationsService {
    constructor(private http: HttpService) {}

    getOrganizations(): Observable<any[]> {
        return this.http.get('/organizations')
    }
}
